"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledTreeItem = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

var _lab = require("@material-ui/lab");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StyledTreeItem = (0, _core.withStyles)(function (theme) {
  return {
    // Reset do estilos nativos do MUI 4 devido especificidade
    root: {
      '&.Mui-selected > .MuiTreeItem-content .MuiTreeItem-label': {
        backgroundColor: 'initial'
      },
      '&.Mui-selected > .MuiTreeItem-content .MuiTreeItem-label:hover,&.Mui-selected:focus > .MuiTreeItem-content .MuiTreeItem-label': {
        backgroundColor: 'initial'
      }
    },
    selected: {
      '& > .MuiTreeItem-content': {
        backgroundColor: function backgroundColor(props) {
          return (0, _core.alpha)(theme.palette[props.color].light, 0.1);
        }
      },
      '&:focus > .MuiTreeItem-content': {
        backgroundColor: function backgroundColor(props) {
          return (0, _core.alpha)(theme.palette[props.color].light, 0.1);
        }
      }
    },
    content: {
      padding: '0 20px',
      '&:hover': {
        backgroundColor: theme.palette.action.hover,
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },
    label: {
      padding: 0,
      '&:hover': {
        backgroundColor: 'initial'
      }
    },
    group: {
      marginLeft: 20,
      marginTop: 4
    },
    iconContainer: {
      '&:empty': {
        display: 'none'
      }
    }
  };
})(function (props) {
  return /*#__PURE__*/_react.default.createElement(_lab.TreeItem, props);
});
exports.StyledTreeItem = StyledTreeItem;